import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container, Row, Col, Form } from "react-bootstrap";
import { ButtonStandard, LoadingSpinner } from "../../components";
import "./ConciliationReport.scss"
import messages from "../../assets/i18n";

function ConciliationReport(props) {

	const dispatch = useDispatch();
	
	const lang = useSelector(state => state.language.name);	    	
    const permissions = useSelector(state => state.authorization.permissions);
    const context = useSelector(state => state.authentication.context);
    const titlePage = messages[lang].conciliationReport;

    const isLoadingConciliationReport = useSelector(state => state.conciliationReport.isLoadingConciliationReport);

    const [reportFilters, setReportFilters] = useState({
        pedido: '',
        conciliacao: '',
        nomeFornecedor: '',
        dataConciliacaoInicial: '',
        dataConciliacaoFinal: '',
        statusComercial: '',
        statusRFM: '',
        notaFiscal: '',
        perfil: '',
        idCd: ''
    });


    const statusOptions = [
        { id: "", message: "Todos" },
        { id: "0", message: "Não enviado" },
        { id: "1", message: "Enviado" },
        { id: "2", message: "Conciliado" },
        { id: "3", message: "Reprovado" },
        { id: "4", message: "Condicional" },
      ];

    const setFilters = (newFilters) => {
        setReportFilters(newFilters)
    };

    useEffect(() => {
        let filters = {...reportFilters};
        filters.perfil = permissions[0];
        if (permissions[0] === 'NPFornec_Renner_Logistica') {
            filters.idCd = context.idCd;
        }
        setFilters(filters);
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getReport = () => {   
		dispatch({
			type: 'GET_CONCILIATION_REPORT',
            payload: {
                filters: reportFilters
            }
		})
	}

	return (
		<div className="conciliation-report-page">
            <Container className="pt-3 justify-content-start">
                <Row className="justify-content-between">
                    <Col className="d-flex align-items-center justify-content-start">
                        <span className="text-3 font-weight-bold header-main pl-2">{titlePage}</span>
                    </Col>
                </Row>
                <Form className="px-3">
                    <Row>
                        <Form.Group as={Col} className="mt-1">
                            <Form.Label className="text-2">{messages[lang].conciliationReportPage.pedido}</Form.Label>
                                <Form.Control
                                    className="text-2 border-radius-full"
                                    placeholder={messages[lang].conciliationReportPage.pedido}
                                    type="text"
                                    defaultValue={''}
                                    onChange={event => setFilters(
                                    { ...reportFilters, pedido: event.target.value },
                                    )}
                                />
                        </Form.Group>
                        <Form.Group as={Col} className="mt-1">
                            <Form.Label className="text-2">{messages[lang].conciliationReportPage.conciliacao}</Form.Label>
                                <Form.Control
                                    className="text-2 border-radius-full"
                                    placeholder={messages[lang].conciliationReportPage.conciliacao}
                                    type="text"
                                    defaultValue={''}
                                    onChange={event => setFilters(
                                    { ...reportFilters, conciliacao: event.target.value },
                                    )}
                                />
                        </Form.Group>
                        <Form.Group as={Col} className="mt-1">
                            <Form.Label className="text-2">{messages[lang].conciliationReportPage.nomeFornecedor}</Form.Label>
                                <Form.Control
                                    className="text-2 border-radius-full"
                                    placeholder={messages[lang].conciliationReportPage.nomeFornecedor}
                                    type="text"
                                    defaultValue={''}
                                    onChange={event => setFilters(
                                    { ...reportFilters, nomeFornecedor: event.target.value },
                                    )}
                                />
                        </Form.Group>

                        
                    </Row>

                    <Row>

                        <Form.Group as={Col} className="mt-1">
                            <Form.Label className="text-2">{messages[lang].conciliationReportPage.statusComercial}</Form.Label>
                            <Form.Control
                                as="select"
                                className="text-2 border-radius-full"
                                type="text"
                                defaultValue={''}
                                onChange={event => setFilters(
                                    { ...reportFilters, statusComercial: event.target.value },
                                )}
                            >
                            {
                                statusOptions.map(value => (
                                    <option key={value.id} value={value.id}>{value.message}</option>
                                ))
                            }      
                            </Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} className="mt-1">
                            <Form.Label className="text-2">{messages[lang].conciliationReportPage.statusRFM}</Form.Label>
                            <Form.Control
                                as="select"
                                className="text-2 border-radius-full"
                                type="text"
                                defaultValue={''}
                                onChange={event => setFilters(
                                    { ...reportFilters, statusRFM: event.target.value },
                                )}
                            >
                            {
                                statusOptions.map(value => (
                                    <option key={value.id} value={value.id}>{value.message}</option>
                                ))
                            }      
                            </Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} className="mt-1">
                            <Form.Label className="text-2">{messages[lang].conciliationReportPage.notaFiscal}</Form.Label>
                                <Form.Control
                                    className="text-2 border-radius-full"
                                    placeholder={messages[lang].conciliationReportPage.notaFiscal}
                                    defaultValue={''}
                                    onChange={event => setFilters(
                                    { ...reportFilters, notaFiscal: event.target.value },
                                    )}
                                />
                        </Form.Group>

                        <Form.Group as={Col} className="mt-1">
                            <Form.Label className="text-2">{messages[lang].conciliationReportPage.dataInicial}</Form.Label>
                                <Form.Control
                                    className="text-2 border-radius-full"
                                    placeholder={messages[lang].conciliationReportPage.dataInicial}
                                    type="date"
                                    defaultValue={''}
                                    onChange={event => setFilters(
                                        { ...reportFilters, dataConciliacaoInicial: event.target.value },
                                    )}
                                />
                        </Form.Group>

                        <Form.Group as={Col} className="mt-1">
                            <Form.Label className="text-2">{messages[lang].conciliationReportPage.dataFinal}</Form.Label>
                                <Form.Control
                                    className="text-2 border-radius-full"
                                    placeholder={messages[lang].conciliationReportPage.dataFinal}
                                    type="date"
                                    defaultValue={''}
                                    onChange={event => setFilters(
                                        { ...reportFilters, dataConciliacaoFinal: event.target.value },
                                    )}
                                />
                        </Form.Group>
                    </Row>
                </Form>
            </Container>

            <Container className="px-4 d-flex justify-content-end">
				<ButtonStandard
					text={messages[lang].getReport}
                    disabled={false}
					textClass="text-2"
					className="btn-sm btn-outline-success btn-standard px-2 mr-2"
					onClick={() => getReport()}/>
			</Container>   

            {
                isLoadingConciliationReport
                ?
                <div className="loader">
                    <LoadingSpinner />
                </div>     
                :
                null
            }
   
		</div>
	)
}

export default withRouter(ConciliationReport);